<template>
    <div class="edit_program_body" v-if="handle_data.question">
        <div class="box question-templeat">
            
            <div class="desc-title">The following agreements and disclaimers will appear at the bottom of your application.</div>   
            
            <div class="edit-item" v-for="(v, k) in handle_data.question.filter(e=>{return e.client_view && !e.is_only_client})" :key="k">
                <div class="line">
                    <div class="name">{{ v.name }}<div class="red">*</div></div>
                    <div class="handle_req">
                        <!-- {{ v.is_switch }} -->
                        <Switch v-if="!v.is_edit && v.label==='i_confirm_that_i_am_18_years_or_older'" :checked="v.is_switch" @click.native="v.is_switch = v.is_switch ? false : true" />
                        <Button v-if="v.is_edit" class="small-btn" size="24" :style="'border'" :border_r="6" @click="saveEdit(v.index)">
                            <svg-icon name="yes-2"/>
                            Save
                        </Button>
                    </div>
                </div>

                <div class="value-box" v-if="!(v.label === 'i_confirm_that_i_am_18_years_or_older' && !v.is_switch) && !v.is_edit && v.client_view">
                    <div class="value">{{ v.client_view.desc }}</div>
                    <!-- <svg-icon name="pen" v-if="!v.is_edit"  @click="v.client_view.tmep_name=v.client_view.name; v.is_edit=true"/> -->
                </div>

                <Field v-if="v.is_edit" :type="'textarea'" :k="v.index" :placeholder="v.client_view.plac" @update="updateValue" :had_value="v.client_view.name" :max_value="100" />

                <div class="url-box" v-if="v.url_title">
                    <div class="url-box-content">
                        <div class="title" v-if="v.client_view.edit_desc" v-html="v.client_view.edit_desc"></div>
                        <Field :type="'text'" :k="v.index" :placeholder="'https://www.website.com'" @update="update" :had_value="v.url"/>
                        <div class="err-msg-box" v-if="v.error">
                            <p class="err-msg" v-html="v.error"></p>
                            <i><svg-icon name="alert" class="icon-left" /></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- save -->
            <div class="save-btn-box-spec">
                <Button class="save-btn" size="40" color="dark-blue" :border_r="6" @click="save()" :is_disabled="disabled_save">
                    Save
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Switch from '@/components/ui/Switch.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Field from '@/components/ui/Field.vue';

export default {
    name: 'ProgramForm-pae',
    emits: ['close','save','del'],

    data() {
        return {
            handle_data:{},
            default_option:["Yes","No","Unsure"],
            is_show_alert_modal:false,
        }
    },

    props: {
        data: {
            type: Object,
            default: {}
        },
        barnd_name:{
            type: String,
            default: '',
        }
    },

    computed: {
        had_opt(){
            return this.handle_data.id===0||this.handle_data.id===1;
        },
        disabled_save(){
            return this.handle_data.question.some(e => e.error) || 
            this.handle_data.question.some(e => e.url !== undefined && e.url === '');
        },
    },

    components: {
        Button,
        NoData,
        Loading,
        Dropdown,
        Switch,
        Checkbox,
        Field,
    },

    methods: {
        isValidUrl(string) {
            // try {
            //     new URL(string);
            //     return true;
            // } catch (err) {
            //     return false;
            // }
            const url_pattern = /^(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?$/;
            return url_pattern.test(string);
        },
        
        update(obj){
            this.handle_data.question[obj.key].error ='';

            this.handle_data.question[obj.key].url = obj.val;
            let url=this.handle_data.question[obj.key].url;
            if (url && !this.isValidUrl(url)){ 
                this.handle_data.question[obj.key].error = `The url format is incorrect.`;
            }
   
        },

        updateValue(obj){
            this.handle_data.question[obj.key].client_view.temp_name = obj.val;
        },

        saveEdit(k){
            let val=this.handle_data.question[k].client_view.temp_name;
            this.handle_data.question[k].client_view.name=val;
            this.handle_data.question[k].client_view.val=val;
            this.handle_data.question[k].is_edit=false;
        },

        save(is_return = false){
            //handle url to other object

            this.handle_data.question.forEach(e => {
                let label1 = 'i_have_read_and_acknowledge_privacy_policy';
                let label2 = 'i_have_read_and_acknowledge_terms_and_conditions';

                if (e.for_label === label1) {
                    let item = this.handle_data.question.find(q => q.label === label1);
                    if (item) {
                        e.val = item.url;
                    }
                }

                if (e.for_label === label2) {
                    let item = this.handle_data.question.find(q => q.label === label2);
                    if (item) {
                        e.val = item.url;
                    }
                }
            });
            

            if (is_return) {
                return [this.handle_data];
            } else {
                this.$emit('save', { data: [this.handle_data], type: 'agreements_disclaimers' });
            }
            
        },

        close(){
            this.$emit('close');
        },

        start(){
            this.handle_data = this.data[0];

            this.handle_data.question.forEach(question => {
                // console.log(question)
                if (question.client_view && question.client_view.desc) question.client_view.desc = question.client_view.desc.replaceAll('{brand}', this.$store.state.user_data.merchant_account.merchant_display_name);
                if (question.client_view && question.client_view.name) question.client_view.name = question.client_view.name.replaceAll('{brand}', this.$store.state.user_data.merchant_account.merchant_display_name);
                if (question.client_view && question.client_view.plac) question.client_view.plac = question.client_view.plac.replaceAll('{brand}', this.$store.state.user_data.merchant_account.merchant_display_name);

                switch (question.label) {
                    case 'i_have_read_and_acknowledge_privacy_policy':
                        question.client_view.edit_desc = `Please provide link to your Privacy Policy.`;
                        break;
                    case 'i_have_read_and_acknowledge_terms_and_conditions':
                        question.client_view.edit_desc = `Please provide link to your Terms & Conditions.`;
                        break;
                }

            });

            //可能有移除URL但沒填回去的狀態，url要塞回去
            this.handle_data.question.forEach(e => {
                let label1 = 'i_have_read_and_acknowledge_privacy_policy';
                let label2 = 'i_have_read_and_acknowledge_terms_and_conditions';

                if (e.label === label1) {
                    let item = this.handle_data.question.find(q => q.for_label === label1);
                    if (item) {
                        e.url = item.val;
                    }
                }

                if (e.label === label2) {
                    let item = this.handle_data.question.find(q => q.for_label === label2);
                    if (item) {
                        e.url = item.val;
                    }
                }
            });
        }
        
    },


    mounted() {
        this.start();
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.edit_program_body {

    .desc-title{
        font-size: 12px;
        color:var(--black-75);
    }

    .line{
        @include flexCenter();

        .small-btn{
            @include flexCenter();
            height: unset;
            color:var(--green);
            border: solid 1px var(--border);

            .svg-icon{
                fill:var(--green);
                margin-right: 4px;
            }
        }
    }

    .name {
        font: var(--font-med-16);
        @include flexCenter();
        flex: 1;
    }

    .value-box{
        @include flexCenter();
        flex: 1;
        margin-top: 4px;
        .value{
            font-size: 14px;
            color:var(--black-75);
            flex: 1;
        }

        .svg-icon{
            width: 16px;
            height: 16px;
            cursor: pointer;
            fill:var(--black-50);
        }
    }

    .url-box{
        .url-box-content{
            border-left: solid 2px #CBD4E1;
            padding-left: 17px;
            .title{
                font:var(--font-med-14);
            }
        }

        .err-msg-box{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color:var(--alert);

            i{
                width: 14px;
                height: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 5px;
            }

            svg{
                width: 10.5px;
                height: 10.5px;
                fill:var(--alert);
            }
        }
    }

    .ui-input{
        margin: 4px 0;
        flex:1;
    }

    .save-btn-box-spec{
        padding: 16px 0 0;

        .ui-button{
            width: 100%;
            text-align: center;
        }
    }
    
}
</style>